import React from 'react';
import { Drawer, Button, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const RightDrawer = ({
  open,
  onClose,
  title,
  children,
  width = 640,
  footer,
  loading = false,
  destroyOnClose = true,
  className = '',
  ...props
}) => {
  const defaultFooter = (
    <div className="flex justify-end gap-2 px-6 py-4 border-t border-gray-200">
      <Button onClick={onClose}>Cancel</Button>
      <Button type="primary" loading={loading} htmlType="submit" form="drawer-form">Save</Button>
    </div>
  );
  const footerContent = footer === false ? null : (footer ?? defaultFooter);

  return (
    <Drawer
      title={
        <div className="flex items-center justify-between">
          <span className="text-lg font-semibold">{title}</span>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          />
        </div>
      }
      placement="right"
      width={width}
      open={open}
      onClose={onClose}
      destroyOnClose={destroyOnClose}
      className={`right-drawer ${className}`}
      closable={false}
      footer={footerContent}
      styles={{ body: { padding: 0 } }}
      {...props}
    >
      <div className="p-6">
        {children}
      </div>
    </Drawer>
  );
};

export default RightDrawer;
